import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/select-type__02.png'
import _imports_1 from '@/assets/select-type__01.png'


const _withScopeId = n => (_pushScopeId("data-v-4a505d68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "r w1200" }
const _hoisted_2 = {
  key: 0,
  class: "z-card intention-tips"
}
const _hoisted_3 = { class: "text-area" }
const _hoisted_4 = {
  key: 0,
  class: "wish",
  ref: "wish"
}
const _hoisted_5 = { class: "wish-title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 校招意向 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("接受其他岗位调剂")
const _hoisted_8 = { class: "wish-title" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 设置为第一志愿 ")
const _hoisted_10 = ["infinite-scroll-disabled"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 添加第二志愿 ")
const _hoisted_12 = {
  key: 1,
  class: "addWish"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 删除新增志愿 ")
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "z-card",
  id: "active0"
}
const _hoisted_16 = { class: "r-title" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 基本信息 ")
const _hoisted_18 = { class: "avatar" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("有")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("无")
const _hoisted_23 = { class: "btn-area" }
const _hoisted_24 = { class: "area" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "r-title" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["id"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r-title" }, "其他", -1))
const _hoisted_34 = { class: "r-title__mini" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 作品 ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("作品附件")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("在线作品链接")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_41 = { class: "r-title__mini" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "r-title__mini" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 内推 ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("内推码")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("内推人")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "联系您的内推人，通过宝盒-内部推荐-我的，即可获取内推码", -1))
const _hoisted_52 = { class: "button" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_54 = { class: "button" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "r-title__mini r-title-mini__selfEvaluation" }, "自我评价", -1))
const _hoisted_57 = {
  key: 0,
  style: {"width":"100%","text-align":"right"}
}
const _hoisted_58 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("投递简历")
const _hoisted_60 = {
  key: 1,
  style: {"width":"100%","text-align":"right"}
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode("更新简历")
const _hoisted_62 = {
  key: 1,
  class: "r-bg"
}
const _hoisted_63 = { class: "w1100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_z_header = _resolveComponent("z-header")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")!
  const _component_RemoveFilled = _resolveComponent("RemoveFilled")!
  const _component_z_upload = _resolveComponent("z-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_z_upload_image = _resolveComponent("z-upload-image")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_get_city = _resolveComponent("get-city")!
  const _component_minus = _resolveComponent("minus")!
  const _component_plus = _resolveComponent("plus")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_z_footer = _resolveComponent("z-footer")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.isFreeLogin)
      ? (_openBlock(), _createBlock(_component_z_header, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.postId && _ctx.resumeType === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_icon, {
              size: 30,
              color: "#3693ff"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_WarningFilled)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipsText, (text, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "text",
                  key: index
                }, _toDisplayString(text), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form, {
        ref: "formRef",
        model: _ctx.form,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          (_ctx.resumeType === 2 && _ctx.postId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_el_checkbox, {
                    modelValue: _ctx.form.isJobTransfer,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isJobTransfer) = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolVolunteers, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "z-card wish_card",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createTextVNode(" 第" + _toDisplayString(_ctx.arabicToChineseNumber(index + 1)) + "志愿 ", 1),
                      (index + 1 === 2 && !_ctx.schoolVolunteers.find((item) => item.isDefault))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "change-volunteer",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeVoluntSort && _ctx.changeVoluntSort(...args)))
                          }, [
                            _createVNode(_component_el_icon, {
                              color: "#409eff",
                              size: "22"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Switch)
                              ]),
                              _: 1
                            }),
                            _hoisted_9
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_row, { gutter: 20 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "职位名称",
                              prop: "positionName"
                            }, {
                              default: _withCtx(() => [
                                (item.newOther)
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 0,
                                      modelValue: item.postName,
                                      "onUpdate:modelValue": ($event: any) => ((item.postName) = $event),
                                      filterable: "",
                                      remote: "",
                                      "reserve-keyword": "",
                                      placeholder: "请输入关键词",
                                      "remote-method": _ctx.querySearchAsync,
                                      loading: _ctx.loading,
                                      "value-key": "id",
                                      onChange: 
                    (val) => {
                      _ctx.changeVolunteer(item, val)
                    }
                  
                                    }, {
                                      default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createElementBlock("div", { "infinite-scroll-disabled": _ctx.busy }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionOptions, (val) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: val.id,
                                              label: val.name,
                                              value: val,
                                              disabled: Boolean(_ctx.schoolVolunteers.find((i) => i.postId == val.id && i.postId != item.postId))
                                            }, null, 8, ["label", "value", "disabled"]))
                                          }), 128))
                                        ], 8, _hoisted_10)), [
                                          [_directive_infinite_scroll, _ctx.getPositionList]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "remote-method", "loading", "onChange"]))
                                  : (_openBlock(), _createBlock(_component_el_input, {
                                      key: 1,
                                      modelValue: item.postName,
                                      "onUpdate:modelValue": ($event: any) => ((item.postName) = $event),
                                      placeholder: "请输入内容",
                                      disabled: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "所属公司",
                              prop: "positionName"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.controlCenterName,
                                  "onUpdate:modelValue": ($event: any) => ((item.controlCenterName) = $event),
                                  placeholder: "请输入内容",
                                  disabled: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: "工作城市",
                              prop: "positionName"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: item.twoWorkPlaceName,
                                  "onUpdate:modelValue": ($event: any) => ((item.twoWorkPlaceName) = $event),
                                  placeholder: "请输入内容",
                                  disabled: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128)),
                (_ctx.schoolVolunteers.length === 1 && !_ctx.isHas)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "addWish",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addVolunteers && _ctx.addVolunteers(...args)))
                    }, [
                      _createVNode(_component_el_icon, {
                        color: "#409eff",
                        size: "22"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CirclePlusFilled)
                        ]),
                        _: 1
                      }),
                      _hoisted_11
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.schoolVolunteers.length === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_el_icon, {
                        color: "#409eff",
                        size: "22",
                        onClick: _ctx.deleteVolunteer
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_RemoveFilled)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true)
              ], 512))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(['r_header', { isFixed: _ctx.isFixed }])
          }, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (type, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.scrollTo(index)),
                  class: _normalizeClass([_ctx.hightLine == index ? 'hightLine' : ''])
                }, _toDisplayString(type.value), 11, _hoisted_14))
              }), 128))
            ])
          ], 2),
          (!_ctx.isFreeLogin)
            ? (_openBlock(), _createBlock(_component_z_upload, {
                key: 1,
                fileType: "resume",
                fileList: _ctx.fileList,
                onSuccessUpload: _ctx.file2Resume,
                onRemoveUpload: _ctx.handleFileRemove,
                onFileParse: _ctx.handleFileParse
              }, null, 8, ["fileList", "onSuccessUpload", "onRemoveUpload", "onFileParse"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              (!(_ctx.postId || _ctx.isFreeLogin))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "r-title__switch",
                    type: "primary",
                    plain: "",
                    onClick: _ctx.handleResumeTypeChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { class: "el-icon--left" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Switch)
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" 切换为" + _toDisplayString(_ctx.resumeType == 1 ? '校招' : '社招'), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_z_upload_image, {
                        fileUrl: _ctx.photoUrl,
                        onSuccessUpload: _ctx.handleAvatarUpload
                      }, null, 8, ["fileUrl", "onSuccessUpload"])
                    ])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resume.base.children, (r, i) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 12,
                    key: i
                  }, {
                    default: _withCtx(() => [
                      (r.value !== 'isTakeOffice' || (r.value === 'isTakeOffice' && _ctx.resumeType === 1 && _ctx.isFreeLogin))
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: r.label,
                            prop: r.value,
                            rules: [
                r.isRequire === false
                  ? {}
                  : {
                      required: true,
                      trigger: 'change',
                      message: `${r.label}不能为空`
                    },
                r.value === 'email'
                  ? {
                      pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z.]+$/,
                      message: '邮箱格式不正确',
                      trigger: 'change'
                    }
                  : {},
                r.value === 'phone' ? { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '手机号码格式不正确' } : {}
              ]
                          }, {
                            default: _withCtx(() => [
                              (r.formType == 'datePicker')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                    key: 0,
                                    modelValue: _ctx.form[r.value],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.form[r.value]) = $event),
                                    type: "date",
                                    placeholder: "选择日期",
                                    format: "YYYY-MM-DD",
                                    "value-format": "YYYY-MM-DD",
                                    onChange: (_v) => _ctx.handleDateChange(_v, r, _ctx.form)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                : (r.value == 'sexKey')
                                  ? (_openBlock(), _createBlock(_component_el_radio_group, {
                                      key: 1,
                                      modelValue: _ctx.form[r.value],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.form[r.value]) = $event)
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_radio, { label: "0" }, {
                                          default: _withCtx(() => [
                                            _hoisted_19
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_radio, { label: "1" }, {
                                          default: _withCtx(() => [
                                            _hoisted_20
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                  : (r.formType == 'select')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 2,
                                        modelValue: _ctx.form[r.value],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.form[r.value]) = $event),
                                        placeholder: "请选择",
                                        onChange: (_v) => _ctx.handleSelectChange(_v, r, _ctx.form),
                                        "value-key": "dataCode",
                                        clearable: ""
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOps[r.selectKey], (_item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: _item.dataCode,
                                              label: _item.dataName,
                                              value: _item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                    : (r.formType === 'provinceCity')
                                      ? (_openBlock(), _createBlock(_component_get_city, {
                                          key: 3,
                                          valueIds: _ctx.form.expectWorkCityId,
                                          num: 2,
                                          onCallback: _ctx.handleProviceCity
                                        }, null, 8, ["valueIds", "onCallback"]))
                                      : (r.value == 'isTakeOffice' && _ctx.resumeType === 1 && _ctx.isFreeLogin)
                                        ? (_openBlock(), _createBlock(_component_el_radio_group, {
                                            key: 4,
                                            onChange: _ctx.handleRelativeRadio,
                                            modelValue: _ctx.form[r.value],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[r.value]) = $event)
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_radio, { label: "1" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_21
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_el_radio, { label: "0" }, {
                                                default: _withCtx(() => [
                                                  _hoisted_22
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onChange", "modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createBlock(_component_el_input, {
                                            key: 5,
                                            disabled: r.disabled,
                                            modelValue: _ctx.form[r.value],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.form[r.value]) = $event),
                                            placeholder: "请输入"
                                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 2
                          }, 1032, ["label", "prop", "rules"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (_ctx.form['isTakeOffice'] === '1' && _ctx.resumeType === 1 && _ctx.isFreeLogin)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      span: 24
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.familyMemberVoList, (item, listIndex) => {
                          return (_openBlock(), _createBlock(_component_el_row, {
                            gutter: 20,
                            class: "group",
                            key: listIndex
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyConfig, (g, i) => {
                                return (_openBlock(), _createBlock(_component_el_col, {
                                  span: 7,
                                  key: i
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      rules: [
                    g.isRequire ? { required: true, message: `${g.label}不能为空` } : {},
                    g.value === 'familyPhone'
                      ? { pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '手机号码格式不正确' }
                      : ''
                  ],
                                      label: g.label,
                                      prop: `familyMemberVoList[${listIndex}][${g.value}]`
                                    }, {
                                      default: _withCtx(() => [
                                        (g.value == 'sex')
                                          ? (_openBlock(), _createBlock(_component_el_select, {
                                              key: 0,
                                              modelValue: _ctx.form.familyMemberVoList[listIndex][g.value],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.familyMemberVoList[listIndex][g.value]) = $event),
                                              onChange: (_v) => _ctx.handleFamilySelectChange(_v, listIndex, g),
                                              placeholder: "请选择",
                                              "value-key": "dataCode",
                                              clearable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOps[g.selectKey], (_item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: _item.dataCode,
                                                    label: _item.dataName,
                                                    value: _item
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                          : (_openBlock(), _createBlock(_component_el_input, {
                                              key: 1,
                                              modelValue: _ctx.form.familyMemberVoList[listIndex][g.value],
                                              "onUpdate:modelValue": ($event: any) => ((_ctx.form.familyMemberVoList[listIndex][g.value]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      _: 2
                                    }, 1032, ["rules", "label", "prop"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _createVNode(_component_el_col, { span: 3 }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                      (_ctx.form.familyMemberVoList.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "btn delete u-flex-center",
                                            onClick: () => _ctx.deleteFamily(listIndex)
                                          }, [
                                            _createVNode(_component_minus, { style: {"width":"100%","height":"100%"} })
                                          ], 8, _hoisted_25))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "btn add u-flex-center",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addNewFamily && _ctx.addNewFamily(...args)))
                                      }, [
                                        _createVNode(_component_plus, { style: {"width":"100%","height":"100%"} })
                                      ])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (type, _index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "z-card",
              id: `active${_index + 1}`,
              key: _index
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.resume[type.key].value) + " ", 1),
                (!_ctx.form[type.key].length)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (_ctx.addRow(type.key))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form[type.key], (item, index) => {
                return (_openBlock(), _createBlock(_component_el_row, {
                  gutter: 20,
                  key: index
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resume[type.key].children, (r) => {
                      return (_openBlock(), _createBlock(_component_el_col, {
                        span: 12,
                        key: r.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: r.label,
                            prop: `${type.key}.${index}.${r.value}`,
                            rules: [
                r.isRequire === false
                  ? {}
                  : {
                      required: true,
                      trigger: 'change',
                      message: `${r.label}不能为空`
                    }
              ]
                          }, {
                            default: _withCtx(() => [
                              (r.formType == 'datePickerRange')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                    key: 0,
                                    modelValue: item[r.value],
                                    "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                    type: "daterange",
                                    "range-separator": "至",
                                    format: "YYYY-MM-DD",
                                    "value-format": "YYYY-MM-DD",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (r.formType == 'select')
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 1,
                                      modelValue: item[r.value],
                                      "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                      placeholder: "请选择",
                                      onChange: (_v) => _ctx.handleSelectChange(_v, r, item),
                                      "value-key": "dataCode",
                                      disabled: _ctx.hasMaxEducationType && r.value === 'educationTypeValue' && item['educationTypeKey'] == '40',
                                      clearable: ""
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOps[r.selectKey], (_item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: _item.dataCode,
                                            label: _item.dataName,
                                            value: _item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]))
                                  : (r.formType == 'textarea')
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        modelValue: item[r.value],
                                        "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                        key: r.label,
                                        type: "textarea",
                                        rows: 4
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock(_component_el_input, {
                                        key: 3,
                                        modelValue: item[r.value],
                                        "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                        placeholder: "请输入"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                            ]),
                            _: 2
                          }, 1032, ["label", "prop", "rules"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_el_col, {
                      span: 6,
                      offset: 18,
                      style: {"text-align":"right"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: ($event: any) => (_ctx.removeRow(type.key, index))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        (index === _ctx.form[type.key].length - 1)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              type: "primary",
                              onClick: ($event: any) => (_ctx.addRow(type.key))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (['educationExperiences', 'workExperiences'].includes(type.key))
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createVNode(_component_el_form_item, {
                      class: "el-form__empty",
                      prop: `${type.key}IsEmpty`,
                      rules: [
              {
                required: true,
                trigger: 'change',
                message: `${_ctx.resume[type.key].value}不能为空`
              }
            ]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form[`${type.key}IsEmpty`],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.form[`${type.key}IsEmpty`]) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1032, ["prop", "rules"])
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_26))
          }), 128)),
          _createElementVNode("div", {
            class: "z-card",
            id: `active${_ctx.typeList.length + 1}`
          }, [
            _hoisted_33,
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              (!_ctx.form.personalWorksList.length)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "text",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addRow('personalWorksList')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.personalWorksList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_row, {
                gutter: 20,
                key: index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        label: "作品类型",
                        prop: `personalWorksList.${index}.worksType`,
                        rules: [
                {
                  required: true,
                  trigger: 'change',
                  message: `作品类型不能为空`
                }
              ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio_group, {
                            modelValue: item.worksType,
                            "onUpdate:modelValue": ($event: any) => ((item.worksType) = $event)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_radio, { label: 1 }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_radio, { label: 2 }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop"])
                    ]),
                    _: 2
                  }, 1024),
                  (item.worksType == 2)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 0,
                        span: 20
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "作品链接",
                            prop: `personalWorksList.${index}.worksUrl`,
                            rules: [
                {
                  required: true,
                  trigger: 'change',
                  message: `作品链接不能为空`
                }
              ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: item.worksUrl,
                                "onUpdate:modelValue": ($event: any) => ((item.worksUrl) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  (item.worksType == 1)
                    ? (_openBlock(), _createBlock(_component_el_col, {
                        key: 1,
                        span: 20
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "作品附件",
                            prop: `personalWorksList.${index}.fileList`,
                            rules: [{ type: 'array', required: true, trigger: 'change', message: `作品附件不能为空` }]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_z_upload, {
                                fileList: item.fileList || [],
                                onRemoveUpload: ($event: any) => (_ctx.handlePWFileRemove(item)),
                                onSuccessUpload: (files) => _ctx.file2PersonalWork(files, item)
                              }, null, 8, ["fileList", "onRemoveUpload", "onSuccessUpload"])
                            ]),
                            _: 2
                          }, 1032, ["prop"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_col, { span: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "描述" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.worksDescription,
                            "onUpdate:modelValue": ($event: any) => ((item.worksDescription) = $event),
                            rows: 4,
                            type: "textarea"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_col, {
                    span: 6,
                    offset: 18,
                    style: {"text-align":"right"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "text",
                        onClick: ($event: any) => (_ctx.removeRow('personalWorksList', index))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _withDirectives(_createVNode(_component_el_button, {
                        type: "text",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addRow('personalWorksList')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, index === _ctx.form.personalWorksList.length - 1]
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['awardsWonsVoList', 'languageAbilityVoList'], (type, _index) => {
              return _createElementVNode("div", { key: _index }, [
                _createElementVNode("div", _hoisted_41, [
                  _createTextVNode(_toDisplayString(_ctx.resume[type].value) + " ", 1),
                  (!_ctx.form[type].length)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "text",
                        onClick: ($event: any) => (_ctx.addRow(type))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_42
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form[type], (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_row, {
                    gutter: 20,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resume[type].children, (r, i) => {
                        return (_openBlock(), _createBlock(_component_el_col, {
                          span: 12,
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                              label: r.label,
                              prop: `${type}.${index}.${r.value}`,
                              rules: [
                  r.isRequire === false
                    ? {}
                    : {
                        required: true,
                        trigger: 'change',
                        message: `${r.label}不能为空`
                      }
                ]
                            }, {
                              default: _withCtx(() => [
                                (r.formType == 'datePicker')
                                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                      key: 0,
                                      modelValue: item[r.value],
                                      "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                      type: "date",
                                      placeholder: "选择日期",
                                      format: "YYYY-MM-DD",
                                      "value-format": "YYYY-MM-DD"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : (r.formType == 'select')
                                    ? (_openBlock(), _createBlock(_component_el_select, {
                                        key: 1,
                                        modelValue: item[r.value],
                                        "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                        placeholder: "请选择",
                                        onChange: (_v) => _ctx.handleSelectChange(_v, r, item),
                                        "value-key": "dataCode"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOps[r.selectKey], (_item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: _item.dataCode,
                                              label: _item.dataName,
                                              value: _item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                                    : (r.formType == 'textarea')
                                      ? (_openBlock(), _createBlock(_component_el_input, {
                                          modelValue: item[r.value],
                                          "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                          key: r.label,
                                          type: "textarea",
                                          rows: 4
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createBlock(_component_el_input, {
                                          key: 3,
                                          modelValue: item[r.value],
                                          "onUpdate:modelValue": ($event: any) => ((item[r.value]) = $event),
                                          placeholder: "请输入"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              ]),
                              _: 2
                            }, 1032, ["label", "prop", "rules"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_component_el_col, {
                        span: 6,
                        offset: 18,
                        style: {"text-align":"right"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (_ctx.removeRow(type, index))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_43
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _withDirectives(_createVNode(_component_el_button, {
                            type: "text",
                            onClick: ($event: any) => (_ctx.addRow(type))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_44
                            ]),
                            _: 2
                          }, 1032, ["onClick"]), [
                            [_vShow, index === _ctx.form[type].length - 1]
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            }), 64)),
            (!_ctx.isFreeLogin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    (!_ctx.pushAreaDisplay)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          style: {"margin-left":"5px"},
                          type: "text",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addRow('push')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_radio_group, {
                          key: 1,
                          modelValue: _ctx.form.recommendedType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.recommendedType) = $event)),
                          style: {"margin-left":"30px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, {
                              label: 1,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, {
                              label: 2,
                              size: "large"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_50
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                  ]),
                  (_ctx.pushAreaDisplay)
                    ? (_openBlock(), _createBlock(_component_el_row, {
                        key: 0,
                        gutter: 24,
                        class: "pushCodeArea"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              (_ctx.form.recommendedType === 1)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    prop: "pushCode",
                                    style: {"margin-bottom":"0"},
                                    rules: [
                  {
                    required: true,
                    trigger: 'change',
                    message: `内推码不能为空`
                  },
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: '内推码只能为数字和字母'
                  }
                ]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input, {
                                        modelValue: _ctx.form.pushCode,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.pushCode) = $event)),
                                        placeholder: "请输入内推码",
                                        style: {"width":"30%"},
                                        maxlength: 10
                                      }, null, 8, ["modelValue"]),
                                      _hoisted_51,
                                      _createElementVNode("div", _hoisted_52, [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.removeRow('push')))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_53
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.form.recommendedType === 2)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createVNode(_component_el_form_item, {
                                      prop: "recommendedName",
                                      rules: [
                    {
                      required: true,
                      trigger: 'change',
                      message: `内推人姓名不能为空`
                    }
                  ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.form.recommendedName,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.recommendedName) = $event)),
                                          placeholder: "请输入姓名",
                                          maxlength: 10
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      prop: "recommendedInfo",
                                      rules: [
                    {
                      required: true,
                      trigger: 'change',
                      message: `内推人工号或手机号不能为空`
                    }
                  ]
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_input, {
                                          modelValue: _ctx.form.recommendedInfo,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.recommendedInfo) = $event)),
                                          placeholder: "请输入工号或手机号",
                                          maxlength: 11
                                        }, null, 8, ["modelValue"]),
                                        _createElementVNode("div", _hoisted_54, [
                                          _createVNode(_component_el_button, {
                                            type: "primary",
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.removeRow('push')))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_55
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _hoisted_56,
              _createVNode(_component_el_row, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        prop: "selfEvaluation",
                        rules: [
                  {
                    required: true,
                    trigger: 'change',
                    message: `自我评价不能为空`
                  }
                ]
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.form.selfEvaluation,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.selfEvaluation) = $event)),
                            rows: 6,
                            type: "textarea"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ], 8, _hoisted_32),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              (!_ctx.isFreeLogin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    (!_ctx.postId)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.validForm(0)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_58
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validForm(1)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_59
                          ]),
                          _: 1
                        }))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.validForm(3)))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_61
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createVNode(_component_z_footer),
    (_ctx.recruitTypeVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("img", {
              src: _imports_0,
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleRecruitTypeChange(1)))
            }),
            _createElementVNode("img", {
              src: _imports_1,
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleRecruitTypeChange(2)))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}